import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../services/firebase';

export const useFavoriteRecipes = () => {
  const [favoriteRecipes, setFavoriteRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!auth.currentUser) {
      setFavoriteRecipes([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'userFavoriteRecipes'),
      where('userId', '==', auth.currentUser.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const favorites = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setFavoriteRecipes(favorites);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { favoriteRecipes, loading };
};

// Export as useFavorites too for compatibility
export const useFavorites = useFavoriteRecipes;

// Default export
export default useFavoriteRecipes;
